var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c("v-autocomplete", {
        attrs: {
          box: "",
          multiple: "",
          clearable: "",
          chips: "",
          "menu-props": { maxHeight: 450 },
          label: "Monitoring Component",
          items: _vm.stationCategoriesNameList,
        },
        on: {
          change: function ($event) {
            return _vm.handleUpdateFilters($event)
          },
        },
        model: {
          value: _vm.selectedCategories,
          callback: function ($$v) {
            _vm.selectedCategories = $$v
          },
          expression: "selectedCategories",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }